import { jsx as _jsx } from "react/jsx-runtime";
import { PluginGizmo } from '../gizmo/PluginGizmo';
import { BillboardIcon } from './BillboardIcon';
export function NodeEditorIcon({ node, registration }) {
    if (registration.isDrawn?.(node) === false)
        return null;
    return (_jsx(PluginGizmo, { drawnFor: "every-node", children: _jsx(BillboardIcon, { node: node, registration: registration }) }));
}
//# sourceMappingURL=NodeEditorIcon.js.map